<style scoped>
    [v-cloak] {
        display: none;
    }

    .recommend {
        background: #f7f7f7;
    }

    .recommend_top {
        width: 100%;
        background: #fff;
        padding: 0.15rem 0.2rem;
    }

    .top_tips1 {
        color: #666666;
        font-size: 0.16rem;
    }

    .top_tips2 {
        color: #2f2f2f;
        font-size: 0.28rem;
        margin-top: 0.1rem;
    }

    .recommend_detail {
        width: 100%;
        height: 1.46rem;
        background: linear-gradient(
                45deg,
                rgba(89, 163, 252, 1) 0%,
                rgba(126, 191, 255, 1) 100%
        );
        border-radius: 0.12rem;
        margin-top: 0.1rem;
        padding: 0.25rem 0.15rem 0 0.2rem;
        position: relative;
    }

    .detail_icon {
        width: 0.76rem;
        height: 0.26rem;
        position: absolute;
        top: 0;
        right: 0;
    }

    .detail_title {
        display: flex;
        align-items: center;
    }

    .detail_title img {
        width: 0.28rem;
        height: 28px;
        border-radius: 0.03rem;
    }

    .detail_title span {
        font-size: 0.2rem;
        font-weight: 500;
        color: #fff;
        margin-left: 0.05rem;
    }

    .detail_bot {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 0.15rem;
    }

    .detail_money {
    }

    .detail_money p:first-child {
        font-size: 0.15rem;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #e2edfe;
        font-weight: 400;
    }

    .detail_money p:last-child {
        font-size: 0.28rem;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #ffffff;
    }

    .detail_btn {
        width: 1.1rem;
        height: 0.36rem;
        background: rgba(255, 255, 255, 1);
        border-radius: 0.18rem;
        color: #5aa3fc;
        font-size: 0.18rem;
        text-align: center;
        line-height: 0.36rem;
    }

    .tips {
        color: #999999;
        font-size: 0.12rem;
        text-align: center;
        margin: 0.15rem 0;
    }

    .list {
        padding: 0 0.15rem;
    }

    .list_box {
        width: 100%;
        /* height: 1.6rem; */
        padding: 0.2rem 0;
        background: rgba(255, 255, 255, 1);
        border-radius: 0.12rem;
        margin-bottom: 0.1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    >>> .van-col {
        padding-right: 0 !important;
    }

    .list_title {
        display: flex;
        align-items: center;
    }

    .list_title span {
        font-size: 0.16rem;
        color: #333;
        font-weight: 500;
        margin-left: 0.06rem;
    }

    .list_icon {
        width: 0.22rem;
        height: 0.22rem;
        border-radius: 0.03rem;
    }

    .list_tip {
        color: #666666;
        font-size: 0.12rem;
        margin-top: 0.1rem;
    }

    .list_money {
        font-size: 0.2rem;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #ff514a;
        margin-top: 0.1rem;
    }

    .list_btn {
        width: 1.18rem;
        height: 0.3rem;
        background: linear-gradient(
                132deg,
                rgba(89, 163, 252, 1) 0%,
                rgba(60, 100, 246, 1) 100%
        );
        border-radius: 0.15rem;
        color: #fff;
        text-align: center;
        line-height: 0.3rem;
        margin-top: 0.1rem;
    }

    .member_toast {
        width: 100px;
        height: 150px;
        display: block;
        background: url("../../assets/img/newpage/member_toast.png") no-repeat center center;
        background-size: cover;
        position: absolute;
        bottom: 3rem;
        right: 0.3rem;
        z-index: 3;
    }

    .wrap_main {
        width: 100%;
        background: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        border-radius: 20px 20px 0px 0px;
    }

    .wrapper {
        padding: 30px 20px 40px 20px;
    }

    .toast_top {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }

    .toast_top_title {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
    }

    .toast_img {
        width: 20px;
        height: 20px;
    }

    .toast_tips {
        font-size: 16px;
        color: #999999;
        margin-top: 6px;
    }

    .toast_title {
        display: flex;
        align-items: center;
        margin-top: 28px;
    }

    .toast_top_title_member {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        background: linear-gradient(121deg, #F5E0BB 0%, #D4A25B 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        color: #333333;
        line-height: 18px;
    }

    .toast_title_icon {
        width: 4px;
        height: 13px;
        background: linear-gradient(135deg, #5983FC 0%, #3C71F6 100%);
        margin-right: 5px;
    }

    .toast_title_tip {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
    }

    .toast_phone {
        font-size: 13px;
        color: #999999;
        margin-top: 6px;
    }

    .toast_main_tip {
        font-size: 13px;
        color: #FF514A;
        line-height: 18px;
        margin-top: 5px;
    }

    .toast_sub_tip {
        font-size: 13px;
        color: #999999;
        line-height: 18px;
    }

    .toast_btn {
        height: 50px;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        box-shadow: 0px 4px 8px 0px #4F80FF;
        border-radius: 25px;
        margin-top: 17px;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        line-height: 50px;
        color: #fff;
    }

    /*.footer{
      background: #FFFFFF;
      text-align: center;
      margin: 10px 15px;
      border: 1px solid #FFFFFF;
    }
    .footer span{
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #F34B4B;
      line-height: 11px;
    }*/

    .top {
        background: #E6EFFF;
    }

    .top .title {
        font-size: 0.18rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2F2F2F;
        margin-bottom: 0.05rem;
    }

    .top .disc {
        display: inline-block;
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: #000;
        margin-right: 3px;
        margin-bottom: 5px;
    }

    .top .content {
        font-size: 0.11rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999;
    }

    .footer {
        padding: 0.15rem 0.2rem;
        text-align: left;
    }

    .footer .disc {
        display: inline-block;
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: #000;
        margin-right: 3px;
        margin-bottom: 5px;
    }

    .footer .content {
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999;
    }

    .rec {
        text-align: center;
        padding: 0rem 0.4rem;
    }

    .rec .rtop {
        padding-top: 0.2rem;
    }

    .rec .rtop .desc {
        font-size: 0.16rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }

    .rec .desc {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF514A;
        margin-top: 0.1rem;
    }

    .rec .btn {
        width: 2.45rem;
        height: 0.5rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        box-shadow: 0rem 0.06rem 0.1rem 0rem #E4EEFA;
        border-radius: 0.25rem;
        line-height: 0.5rem;
        text-align: center;
        margin: 0.2rem auto;
    }

    .rec .btn span {
        font-size: 0.17rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }

</style>

<template>
    <div>
        <div v-if="isRecommend">
            <div>

                <!--<div class="top">
                  <div style="padding: 0.15rem 0.2rem;">
                    <div class="title">恭喜，申请提交成功</div>
                    <div>
                      <span class="disc"></span>
                      <span class="content"><span style="color: #333;">请保持电话畅通&nbsp;&nbsp;</span><span>通过后</span><span style="color: #FF514A;">48小时内会有专业顾问</span><span>与您电话沟通，致电人员均属平台合作的第三方机构</span></span>
                    </div>
                    <div>
                      <span class="disc"></span>
                      <span class="content"><span style="color: #333;">平台不会向您收取任何费用&nbsp;&nbsp;</span><span>到账前以卡号错误、流水不足等理由收</span><span style="color: #FF514A;">“验资费”、“解冻费”</span><span>等行为都是诈骗，请提高安全防范意识，</span><span style="color: #FF514A;">谨防诈骗</span></span>
                    </div>
                  </div>
                </div>-->

                <div class="recommend">
                    <div class="recommend_top">
                        <p class="top_tips1">恭喜你，初审已通过</p>
                        <p class="top_tips2">请立即申请</p>
                        <div class="recommend_detail">
                            <img class="detail_icon"
                                 src="@/assets/img/newpage/img_sqd.png"
                                 alt="">
                            <div class="detail_title">
                                <img v-if="list[0]"
                                     :src="list[0].icon"
                                     alt="">
                                <span v-if="list[0]">{{list[0].name}}</span>
                            </div>
                            <div class="detail_bot">
                                <div class="detail_money">
                                    <p>可借额度(元)</p>
                                    <p v-if="list[0]">{{list[0].limit}}</p>
                                </div>
                                <div v-if="list[0]"
                                     class="detail_btn"
                                     @click="toMember(list[0].pageUrl,list[0].id)">一键申请
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="tips">检测到您在以下产品有可借额度，成功率高达95%</p>
                    <div class="list">
                        <van-row gutter="20">
                            <van-col span="12"
                                     v-for="(item,index) in newList"
                                     :key="index">
                                <div class="list_box">
                                    <div class="list_title">
                                        <img class="list_icon"
                                             :src="item.icon"
                                             alt="">
                                        <span>{{item.name}}</span>
                                    </div>
                                    <p class="list_tip">可借额度(元)</p>
                                    <p class="list_money">{{item.limit}}</p>
                                    <div class="list_btn"
                                         @click="toMember(item.pageUrl,item.id)">一键申请
                                    </div>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                </div>

                <div class="toast" v-if="showToast">
                    <van-overlay :show="showOverlay" @click="showOverlay = false">
                        <div class="wrap_main" @click.stop>
                            <div class="wrapper">
                                <div v-if="!ifMember">
                                    <div class="toast_top">
                                        <p class="toast_top_title">恭喜 申请提交成功！</p>
                                        <img class="toast_img" @click="showOverlay = false"
                                             src="@/assets/img/newpage/close_toast.png" alt="">
                                    </div>
                                    <div class="toast_tips">请查看以下注意事项：</div>
                                </div>
                                <div v-else>
                                    <div class="toast_top">
                                        <p class="toast_top_title_member">订单已进入加速审核通道！</p>
                                        <img class="toast_img" @click="showOverlay = false"
                                             src="@/assets/img/newpage/close_toast.png" alt="">
                                    </div>
                                    <div class="toast_tips">提速<span class="toast_top_title_member">50%</span> 预计需要<span
                                            class="toast_top_title_member">24小时</span>完成
                                    </div>
                                    <div class="member_toast"></div>
                                </div>

                                <div class="toast_title">
                                    <div class="toast_title_icon"></div>
                                    <div class="toast_title_tip">请保持电话畅通</div>
                                </div>
                                <div class="toast_phone">若初审通过，48小时内<span style="color: #FF514A;">会有专业顾问与您电话沟通</span>！致电 人员均属平台合作的第三方机构
                                </div>
                                <div class="toast_title">
                                    <div class="toast_title_icon"></div>
                                    <div class="toast_title_tip">平台承诺不会向用户收取任何费用</div>
                                </div>
                                <div class="toast_main_tip">
                                    <p style="color: #999999;">贷款到账前以卡号错误、流水不足等理由收费<span style="color: #FF514A;">“验资费”、“解冻费”等行为都是诈骗</span>，请提高安全防范意识，谨防诈骗。
                                    </p>
                                </div>
                                <!--<div class="toast_sub_tip">请勿相信！若您无视该申明，因此产生的后果由您承担。若发现任何违规操作。请第一时间在本平台内发起投诉，我们会尽可能的提供协助，保障您的合法权益不受伤害。</div>-->
                                <div class="toast_btn" @click="showOverlay = false">{{time}}s 后自动关闭</div>
                            </div>
                        </div>
                    </van-overlay>
                </div>

                <!--<div class="footer">
                  <span>平台不会向您收取任何费用，请注意以下事项 1.境外电话都是诈骗; 2.要求加QQ、微信在线审核, 网签电子合同, 以传票要挟等; 3.要求提前缴纳保证金、服务费、中介费、测试金等;
                  4. 要求提供银行卡密码、验证码等,以上皆为诈骗,请勿相信! </span>
                </div>-->
                <div class="footer">
                    <div>
                        <span class="disc"></span>
                        <span class="content"><span style="color: #333;">请保持电话畅通  </span><span>若初审通过，</span><span
                                style="color: #FF514A;">48小时内会有专业顾问</span><span>与您电话沟通！</span></span>
                    </div>
                    <div>
                        <span class="disc"></span>
                        <span class="content"><span
                                style="color: #333;">平台不会向您收取任何费用  </span><span>贷款到账前以卡号错误、流水不足等理由收费</span><span
                                style="color: #FF514A;">“验资费”、“解冻费”</span><span>等行为都是诈骗，请提高安全防范意识，</span><span
                                style="color: #FF514A;">谨防诈骗</span></span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="rec">
            <div class="rtop">
                <img src="../../assets/img/newpage/recommend_success.png" alt="" style="width: 109px;height: 90px;">
                <div class="desc">订单提交成功</div>
            </div>
            <div class="desc">请保持电话畅通 通过后48小时内会有专业顾问与您电话 沟通，致电人员均属平台合作的第三方机构</div>
            <div class="btn" @click="toRedirect"><span>查看订单进度</span></div>
            <!--<div class="recommend">
              <div class="recommend_top">
                <p class="top_tips1">您好，初审已通过</p>
                <p class="top_tips2" style="color: rgb(72,122,254);" @click="toRedirect">请查看订单进度</p>
              </div>
            </div>-->
        </div>
    </div>

</template>

<script>
    export default {
        data() {
            return {
                list: [],
                newList: [],
                stage: 0,//stage:0 app跳转 ；1落地页跳转
                partnerId: '',
                showOverlay: true,
                time: 3,
                ifMember: false,
                showToast: true,
                isRecommend: true
            }
        },
        created() {
            this.stage = this.$route.query.stage ? this.$route.query.stage : 0;
            this.partnerId = this.$route.query.partnerId ? this.$route.query.partnerId : '';
            this.showToast = this.$route.query.showToast == undefined ? true : this.$route.query.showToast;
            this.util.title('推荐贷款');
            this.checkRecommend();
            this.getList();
            console.log(this.stage)
            if (this.stage == 1) {//
                let json = {
                    event_key: 'h5_recommend1_view',
                    gmtTimestamp: new Date().getTime(),
                    uvui: localStorage.getItem("uvui"),
                    partner_id: this.partnerId
                }
                this.toCountPoint(json);
            } else {
                let json = {
                    event_key: 'h5_recommend_view',
                    os: localStorage.getItem("os"),
                    app_market_channel: localStorage.getItem("appMarketChannel"),
                    app_version: localStorage.getItem("appVersion"),
                    customer_id: localStorage.getItem("customerId"),
                    udid: localStorage.getItem("udid"),
                    package_name: localStorage.getItem("packageName"),
                }
                this.toCountPoint(json);
            }
            this.isMember();
        },
        methods: {
            getList() {
                this.$get("/app/api/v2/home/postLoanProductList").then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        this.list = res.data;
                        console.log(this.list)
                        this.newList = this.list.slice(0);
                        this.newList.splice(0, 1);
                        this.setTimer();
                    } else {
                        this.util.toast({msg: res.message});
                    }
                })
            },
            toMember(url, id) {
                if (this.stage == 1) {
                    let json = {
                        event_key: 'h5_recommend1_product_click',
                        gmtTimestamp: new Date().getTime(),
                        product_id: id,
                        uvui: localStorage.getItem("uvui"),
                        partner_id: this.partnerId
                    }
                    this.toCountPoint(json);
                } else {
                    let json = {
                        event_key: 'h5_recommend_product_click',
                        url: url,
                        os: localStorage.getItem("os"),
                        app_market_channel: localStorage.getItem("appMarketChannel"),
                        app_version: localStorage.getItem("appVersion"),
                        customer_id: localStorage.getItem("customerId"),
                        udid: localStorage.getItem("udid"),
                        package_name: localStorage.getItem("packageName"),
                        product_id: id
                    }
                    this.toCountPoint(json);
                }
                window.location.href = url;
            },
            //统计埋点
            toCountPoint(json) {
                this.$get('/app/api/v1/newEventTrace', json)
                    .then(res => {
                        if (res.code == 200) {
                        }/* else {
                            this.util.toast({msg: res.message})
                        }*/
                    })
                    .catch(error => {
                    });
            },
            //查询是否是会员
            isMember() {
                this.$get("/app/v1.0/memeber/isMember")
                    .then((res) => {
                        if (res.code == 200) {
                            if (res.data != null) {
                                this.ifMember = res.data;
                            }
                        } else {

                        }
                    })
                    .catch((error) => {
                    });
            },
            setTimer() {
                const _timer = setTimeout(() => {
                    this.time--
                    if (this.time === 0) {
                        clearTimeout(_timer)
                        this.showOverlay = false
                    } else {
                        this.setTimer()
                    }
                }, 1000)
            }, checkRecommend() {
                let param = {
                    channel: localStorage.getItem("appMarketChannel")
                }
                this.$get('/app/api/v1/config/getRecommendConfig', param)
                    .then(res => {
                        console.log(res)
                        if (res.code == 200) {
                            this.isRecommend = res.data;
                        }
                    })
                    .catch(error => {
                    });
            }, toRedirect() {
                this.$router.push({
                    path: '/loan/applyStatus?orderType=1&webRefresh=1',
                });
            },


        }
    }
</script>
